"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBrowserEnvironment = void 0;
/**
 * Defines if the current environment is a browser environment. This is
 * determined by checking if the `window` and `document` objects are defined.
 */
exports.isBrowserEnvironment = typeof window !== "undefined" && typeof document !== "undefined";